import { reducer as bootstrapReducer } from '@app/main-store/bootstrap.reducer';
import { reducer as featureFlagsReducer } from '@app/main-store/feature-flags.reducer';
import { reducer as integrationsReducer } from '@app/main-store/integrations/integrations.reducer';
import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import { MainState } from './main-state';

export const reducers: ActionReducerMap<MainState> = {
  bootstrap: bootstrapReducer,
  router: routerReducer,
  featureFlags: featureFlagsReducer,
  integrations: integrationsReducer,
};
